// extracted by mini-css-extract-plugin
export default {"hidden":"styles_hidden__HKM6J","visible":"styles_visible__ANea9"};